import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DivLayout from 'components/sales/divLayout/divLayout';
import './renewalRequestDetails.css';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';

const RenewalRequestDetails = ({
  requestDetails,
  getRenewalRequestDetails,
  requestStatus,
  updateRequestStatus,
  match,
  history
}) => {

  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [actionData, setActionData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [modificationModal, setModificationModal] = useState(false);
  const [isRejectedModal, setIsRejectedModal] = useState(false);
  const [isApprovedModal, setIsApprovedModal] = useState(false);

  const [isSomethingWentWrongModal, setIsSomethingWentWrongModal] = useState(false);
  const [payload,setPayload]=useState(null);
  
  const handleModalHide = () => setIsRejectedModal(false);
  const handleRejectModalHide = () => {
    history.goBack();
    setIsSuccessModel(false);
  }
  
  const successIconBox = (text, func) => {
    return (
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{text}</h5>
          <Link to="#" onClick={func} className="btn btn-transparent">
            {localization.returnToApproval}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
    );
  };

  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);
  const handleApprovedModalHide = () => {
    setIsApprovedModal(false);
};

const handleRejectedModalHide = () => {
    setIsRejectedModal(false);
};

const handleSomethingWentWrongModalHide = () => {
  setIsSomethingWentWrongModal(false);
};
const updateApproval = async (action) => {
    setActionData(action);
    const newPayload = {
        request_id: match.params.id,
        status: action === 'accept' ? 2 : 4,
        remarks: action === 'reject' ? remarks.remarks : ''
    };
    setPayload(newPayload);

    setIsLoading(true);

    try {
        if (action == 'accept') {
            const response = await updateRequestStatus(newPayload);
            if (response) {
                setIsApprovedModal(true);
            }else {
              setIsSomethingWentWrongModal(true);
            }
        }else{
            setIsRejectedModal(true)
        }
    } catch (error) {
        console.error('API error:', error);
        setIsSomethingWentWrongModal(true);
    } finally {
        setIsLoading(false);
    }
};

const handleContinue = async () => {
    setIsRejectedModal(false);
    setIsLoading(true);

    const updatedPayload = { ...payload, remarks: remarks.remarks };

    try {
        const response = await updateRequestStatus(updatedPayload);
        if (response) {
            setIsSuccessModel(true);
        } else {
            setIsSomethingWentWrongModal(true);
        }
    } catch (error) {
        console.error('API error:', error);
        setIsSomethingWentWrongModal(true);
    } finally {
        setIsLoading(false);
    }
};

useEffect(() => {
    if (getRenewalRequestDetails !== null) {
      (async () => {
        setIsLoading(true);
        await getRenewalRequestDetails(match.params.id);
        setIsLoading(false);
      })();
    }
  }, [getRenewalRequestDetails]);

  const headerButtons = () => {
        if(requestDetails?.status=='Pending for manager approval'){
            return (
                <>
                 <Button
                    onClick={() => updateApproval('accept')}
                    className="filter-hamburger btn btn-success"
                >
                    Approve
                </Button>
                <Button
                    onClick={() => updateApproval('reject')}
                    className="filter-hamburger btn btn-danger"
                >
                    Reject
                </Button>
                </>
            )
        }

    }

  return (
    <Layout
      title={localization.approvedSalesLeadListing}
      isLoading={isLoading}
      isGoback
      Buttons={headerButtons}
    >
        <ModalPop
            title={
              actionData && actionData.action === 'reject'
                  ? localization.rejectConf
                  : localization.conf
            }
            show={isRejectedModal}
            handleModalHide={handleModalHide}
            actionData={actionData}
        >
          {actionData && actionData === 'reject' && (
              <Fragment>
                <div className="" >
                  <div className="">
                    <h5>{'Please add a Remarks to continue'}</h5>
                    <div className=''>
                      <TextAreaInput
                            type="text"
                            rows={3}
                            className={`inline-css scrollbar-styling`}
                            label="Add Remarks"
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            fwidth={true}
                            style={{ width: '100% !important' }}
                            inputValue={remarks.remarks}
                            handleChange={
                              (e) => {
                                setRemarks({ ...setRemarks, remarks: e.target.value })
                              }
                            }
                            // handleChange={(val) =>{
                            //   setRemarks({ ...setRemarks, remarks: val });}
                            // }
                        />
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        className="btn btn-primary"
                        onClick={handleContinue}
                        disabled={!remarks.remarks}
                      >
                        {localization.continue}{' '}
                        <img src="../images/arrow-right.png" alt="" />
                      </Button>
                    </div>
                  </div>
                </div>
          </Fragment>
          )}
      </ModalPop>
      <ModalPop
        title={'Contract Renewal Request Rejected Successfully'}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox('Request Rejected Successfully', handleRejectModalHide)}
      </ModalPop>

      <ModalPop
                title={localization.conf}
                show={isApprovedModal}
                handleModalHide={handleApprovedModalHide}
                keyboard
                backdrop
                closeButton={false}

            >
                <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{'Contract Renewal Request Approved Successfully'}</h5>
                <a
                    className="btn btn-primary mb-4"
                    onClick={() => history.goBack()}
                  >
                    Back to list
                  </a>
                </div>
            </ModalPop>
        <div className="panel-card card-details" width="100%">
        <div className="panel-heading">{'Request Details'}</div>
            <div className="panel-body">
                <div className="details-listing detail_alignment">
                    {/* General Request Details */}
                    <DivLayout
                        heading={'Site Number'}
                        data={requestDetails?.site_no || 'N/A'}
                    />
                    {/* <DivLayout
                        heading={'Live Date'}
                        data={requestDetails?.live_date || 'N/A'}
                    />
                    <DivLayout
                        heading={'Expiry Date'}
                        data={requestDetails?.expiry_date || 'N/A'}
                    /> */}
                    <DivLayout
                        heading={'Contract Length'}
                        data={requestDetails?.contract_length ? `${requestDetails?.contract_length} month(s)` : 'N/A'}
                    />
                    <DivLayout
                        heading={'Status'}
                        data={requestDetails?.status || 'N/A'}
                    />
                    <DivLayout
                        heading={'Client Name'}
                        data={requestDetails?.client_name || 'N/A'}
                    />
                    <DivLayout
                        heading={'Payment Term'}
                        data={requestDetails?.payment_term || 'N/A'}
                    />
                    <DivLayout
                        heading={'Contract Type'}
                        data={requestDetails?.commercial_type || 'N/A'}
                    />
                    {requestDetails?.remarks && <DivLayout
                        heading={'Rejection Remarks'}
                        data={requestDetails?.remarks || 'N/A'}
                    />}
                    <DivLayout heading={'Requested By'} data={requestDetails?.created_by_user_name || 'N/A'} />
                    <DivLayout heading={'Requested At'} data={requestDetails?.created_at || 'N/A'} />
                </div>
                <div className="panel-heading">{'Gate Details'}</div>
        <div className="details-listing detail_alignment">
            {requestDetails?.gate_data && requestDetails?.gate_data.length > 0 ? (
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Gate Name</th>
                            <th>AMC Type</th>
                            <th>Price(Rs.)</th>
                            <th>Software Price(Rs.)</th>
                            <th>Total Gate Price(Rs.)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requestDetails?.gate_data.map((gate, index) => (
                            <tr key={index}>
                                <td>{gate?.name || 'N/A'}</td>
                                <td>{(gate?.amc=='comp')?'Comprehensive':(gate?.amc=='nonComp')?'Non-Comprehensive':'N/A'}</td>
                                <td>{gate?.hardware_price || 'N/A'}</td>
                                <td>{gate?.software_price || 'N/A'}</td>
                                <td>{(Number(gate?.hardware_price)+Number(gate?.software_price)) || 'N/A'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <DivLayout heading={'Gate Data'} data={'No Gate Data'} />
            )}
            <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-md-6" style={{ display: 'flex',justifySelf: 'end',marginRight: 'unset'}}>
                    <DivLayout mkClass="additionalChargesRemarkCss details-list" heading={'Additional Cost Remarks'} data={requestDetails?.additional_cost_remarks || 'N/A'} />
                </div>
                <div className="col-md-6" style={{display: 'flex',justifyContent: 'flex-end' ,marginLeft:'-25px'}}>
                    <DivLayout mkClass="additionalChargesRemarkCss details-list" heading={'Additional Cost (Rs.)'} data={requestDetails?.additional_cost || 'N/A'} />
                </div>
            </div>

            {/* Total Cost centered below */}
            <div
                className="row"
                style={{
                    marginTop: '15px',
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: 'medium'
                }}
            >
                <div
                    className="col-12"
                    style={{
                        maxWidth: '300px', // Restricting the width
                        textAlign: 'center', // Ensuring text is centered within
                        margin: '0 auto' // Centering within the row
                    }}
                >
                    <DivLayout
                        mkClass="totalCostCss details-list"
                        heading={'Total Cost (Rs.)'}
                        data={requestDetails?.total_cost || 'N/A'}
                    />
                </div>
            </div>
            {/* <DivLayout mkClass={`additionalChargesRemarkCss details-list`}
                        heading={'Additional Cost Remarks'}
                        data={requestDetails?.additional_cost_remarks || 'N/A'}
                    />
            <DivLayout mkClass={`additionalChargesRemarkCss details-list`} heading={'Additional Cost (Rs.)'} data={requestDetails?.additional_cost || 'N/A'} />
            <DivLayout mkClass={`totalCostCss details-list`} heading={'Total Cost (Rs.)'} data={requestDetails?.total_cost || 'N/A'} /> */}

        </div>

                {/* Increment Details Section */}

                <div className="panel-heading">{'Increment Details'}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <DivLayout heading="Increment Type" data={requestDetails?.increament_data?.inc?.increament_type==='nonUniform'?'Non-Uniform':requestDetails?.increament_data?.inc?.increament_type} />
                            {requestDetails?.increament_data?.inc?.increament_type === "nonUniform" ? (
                                // Display subscription amounts if nonUniform
                                requestDetails?.increament_data?.input?.map((item, index) => (
                                <DivLayout key={index} heading={`Subscription Amount ${index + 1}`} data={item?.subscription_amounts} />
                                ))
                            ) : (
                                <div>
                                <DivLayout heading="Duration" data={requestDetails?.increament_data?.inc?.duration} />
                                <DivLayout heading="Increment Amount" data={requestDetails?.increament_data?.inc?.increament_amount} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div className="panel-heading">{'Client Alignment'}</div>
                            <div className="panel-body">
                              <div className="details-listing detail_alignment">
                                    <DivLayout heading="Client Alignment " data={requestDetails?.client_status} />
                                    <DivLayout heading="Alignment Reason" data={requestDetails?.client_status_reason} />
                                    <DivLayout heading="Other Remarks" data={requestDetails?.client_status_reason_remarks} />
                              </div>
                            </div> */}
                
    </div>

    </Layout>
  );
};

export default RenewalRequestDetails;
